<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.9027 18.4686L29.3482 10H27.5838L21.1189 17.3532L15.9555 10H10L17.8082 21.1193L10 30H11.7644L18.5915 22.2348L24.0445 30H30L21.9027 18.4686ZM19.4861 21.2173L18.695 20.1101L12.4002 11.2997H15.1102L20.1902 18.4099L20.9813 19.5172L27.5847 28.7594H24.8746L19.4861 21.2173Z"
      fill="currentColor"
    />
    <rect
      x="0.5"
      y="0.5"
      width="39"
      height="39"
      rx="19.5"
      stroke="currentColor"
    />
  </svg>
</template>
